import { PluginKey } from 'prosemirror-state'
import { State } from './Types'

export const MENTIONS_PLUGIN_KEY = new PluginKey<State>('mentions')

export const ANCHOR_DATA_ATTR = 'data-mentions-anchor'

export const SELECT_KEYS = ['Enter', 'Tab']
